import { getTile, inBounds, unitAt } from "./grid";
import { tileDef } from "./terrain";
import type { Coord, GameState, Tile, Unit, UnitKind } from "./types";
import { movementType } from "./units";

export function terrainEnterCost(tile: Tile, unitKind: UnitKind): number | null {
  return tileDef(tile.kind).enterCost[movementType(unitKind)];
}

export function canTraverse({
  state,
  unit,
  coord,
}: {
  state: GameState;
  unit: Unit;
  coord: Coord;
}): boolean {
  if (!inBounds(state, coord)) return false;
  const mtype = movementType(unit.kind);
  if (mtype === "air") {
    const occupant = unitAt(state, coord);
    if (occupant && occupant.owner !== unit.owner) return false;
    return true;
  }
  const tile = getTile(state, coord);
  if (tileDef(tile.kind).enterCost[mtype] === null) return false;
  const occupant = unitAt(state, coord);
  if (occupant && occupant.owner !== unit.owner) return false;
  return true;
}
